// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"619321d6","81":"9d999e42","334":"947533f2","401":"63f0c12f","678":"1d3a9cdd","815":"f3b5ff62"}[chunkId] + ".chunk.js";
};